export const getUnitOptions = (t: (key: string) => string) => [
  { value: 'pce', label: t('units.pce') },
  { value: 'g', label: t('units.g') },
  { value: 'kg', label: t('units.kg') },
  { value: 'l', label: t('units.l') },
  { value: 'cl', label: t('units.cl') },
  { value: 'ml', label: t('units.ml') },
  { value: 'brin', label: t('units.brin') },
  { value: 'pincée', label: t('units.pincée') },
  { value: "cc", label: t('units.cc')},
  { value: "cs", label: t('units.cs')},
  { value: "verre", label: t('units.verre')},
  { value: "verre à liqueur", label: t('units.verreALiqueur')},
  { value: "pm", label: t('units.pm')},
  { value: "qs", label: t('units.qs')},
  { value: "sachet", label: t('units.sachet')},
  { value: "dose", label: t('units.dose')},
  { value: "branche", label: t('units.branche')},
  { value: "botte", label: t('units.botte')},
  { value: "boîte", label: t('units.boite')},
  { value: "gousse", label: t('units.gousse')},
  { value: "tranche", label: t('units.tranche')},
];

// For backwards compatibility
const unitOptions = getUnitOptions((key: string) => key.split('.')[1] || key);
export default unitOptions
